// https://stackoverflow.com/questions/19327749/javascript-blob-filename-without-link/19328891#19328891
export default function downloadContent(
  content: string,
  { fileName, contentType }: { fileName: string; contentType: string }
): void {
  const blob = new Blob([content], { type: contentType });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", fileName);
  document.body.appendChild(link); // Required for FF

  link.click();
}
